export const DEAL_FETCH_REQUESTED = 'DEAL_FETCH_REQUESTED'
export const DEAL_FETCH_SUCCESS = 'DEAL_FETCH_SUCCESS'
export const PROPOSAL_CREATE_SUCCESS = 'PROPOSAL_CREATE_SUCCESS'
export const DEAL_UPDATE_REQUESTED = 'DEAL_UPDATE_REQUESTED'
export const DEAL_UPDATE_SUCCESS = 'DEAL_UPDATE_SUCCESS'
export const DEAL_PROPERTY_UPDATE = 'DEAL_PROPERTY_UPDATE'
export const PROPOSAL_FETCH_SUCCESS = 'PROPOSAL_FETCH_SUCCESS'
export const DEAL_UPDATE_STATUS_REQUESTED = 'DEAL_UPDATE_STATUS_REQUESTED'
export const DEAL_UPDATE_STATUS_SUCCESS = 'DEAL_UPDATE_STATUS_SUCCESS'
export const DEAL_COMPANIES_FETCH_REQUESTED = 'DEAL_COMPANIES_FETCH_REQUESTED'
export const DEAL_COMPANIES_FETCH_SUCCESS = 'DEAL_COMPANIES_FETCH_SUCCESS'
export const COMPANIES_FETCH_REQUESTED = 'COMPANIES_FETCH_REQUESTED'
export const DEAL_TASKS_FETCH_REQUESTED = 'DEAL_TASKS_FETCH_REQUESTED'
export const DEAL_TASKS_FETCH_SUCCESS = 'DEAL_TASKS_FETCH_SUCCESS'
export const DEAL_TASK_MARK_COMPLETED_REQUESTED = 'DEAL_TASK_MARK_COMPLETED_REQUESTED'
export const DEAL_TASK_MARK_COMPLETED_SUCCESS = 'DEAL_TASK_MARK_COMPLETED_SUCCESS'
export const DEAL_TASK_MARK_NOT_COMPLETED_REQUESTED = 'DEAL_TASK_MARK_NOT_COMPLETED_REQUESTED'
export const DEAL_TASK_MARK_NOT_COMPLETED_SUCCESS = 'DEAL_TASK_MARK_NOT_COMPLETED_SUCCESS'
export const UPDATE_DEAL_TASK_SUCCESS = 'UPDATE_DEAL_TASK_SUCCESS'
export const UPDATE_DEAL_TASK_REQUESTED = 'UPDATE_DEAL_TASK_REQUESTED'
export const USERS_FETCH_REQUESTED = 'USERS_FETCH_REQUESTED'
export const CREATE_DEAL_BOARD_TASK_REQUESTED = 'CREATE_DEAL_BOARD_TASK_REQUESTED'
export const DEAL_PROPOSALS_TEMPLATES_FETCH_SUCCESS = 'DEAL_PROPOSALS_TEMPLATES_FETCH_SUCCESS'
export const DEAL_PROPOSALS_TEMPLATES_FETCH_REQUESTED = 'DEAL_PROPOSALS_TEMPLATES_FETCH_REQUESTED'
export const PROPOSALS_DEAL_BOARD_DATA_FETCH_REQUESTED = 'PROPOSALS_DEAL_BOARD_DATA_FETCH_REQUESTED'
export const PROPOSALS_DEAL_BOARD_DATA_FETCH_SUCCESS = 'PROPOSALS_DEAL_BOARD_DATA_FETCH_SUCCESS'
export const DEAL_PROPOSAL_UPDATE_STATUS_REQUESTED = 'DEAL_PROPOSAL_UPDATE_STATUS_REQUESTED'
export const DEAL_PROPOSAL_UPDATE_STATUS_SUCCESS = 'DEAL_PROPOSAL_UPDATE_STATUS_SUCCESS'
export const CREATE_DEAL_PROPOSAL_TASK_REQUESTED = 'CREATE_DEAL_PROPOSAL_TASK_REQUESTED'
export const CREATE_DEAL_PROPOSAL_TASK_SUCCESS = 'CREATE_DEAL_PROPOSAL_TASK_SUCCESS'
export const UPDATE_DEAL_BOARD_PROPOSAL_TASK_REQUESTED = 'UPDATE_DEAL_BOARD_PROPOSAL_TASK_REQUESTED'
export const UPDATE_DEAL_BOARD_PROPOSAL_TASK_SUCCESS = 'UPDATE_DEAL_BOARD_PROPOSAL_TASK_SUCCESS'
export const CREATE_DEAL_TASK_REQUESTED = 'CREATE_DEAL_TASK_REQUESTED'
export const CREATE_DEAL_TASK_SUCCESS = 'CREATE_DEAL_TASK_SUCCESS'
export const DEAL_GENERATE_PROPOSALS_REQUESTED = 'DEAL_GENERATE_PROPOSALS_REQUESTED'
export const DEAL_GENERATE_PROPOSALS_SUCCESS = 'DEAL_GENERATE_PROPOSALS_SUCCESS'
export const DEAL_PROPOSALS_ADD_SELECTED_TEMPLATE_TO_STORE =
  'DEAL_PROPOSALS_ADD_SELECTED_TEMPLATE_TO_STORE'
export const DEAL_PROPOSALS_ADD_EDITED_SELECTED_TEMPLATE_TO_STORE =
  'DEAL_PROPOSALS_ADD_EDITED_SELECTED_TEMPLATE_TO_STORE'
export const DEAL_ADD_INTERNAL_TEAM_REQUESTED = 'DEAL_ADD_INTERNAL_TEAM_REQUESTED'
export const DEAL_ADD_INTERNAL_TEAM_SUCCESS = 'DEAL_ADD_INTERNAL_TEAM_SUCCESS'
export const DEAL_REMOVE_INTERNAL_TEAM_REQUESTED = 'DEAL_REMOVE_INTERNAL_TEAM_REQUESTED'
export const DEAL_REMOVE_INTERNAL_TEAM_SUCCESS = 'DEAL_REMOVE_INTERNAL_TEAM_SUCCESS'
export const DEAL_ADD_NOTE_SUCCESS = 'DEAL_ADD_NOTE_SUCCESS'
export const DEAL_ADD_NOTE_REQUESTED = 'DEAL_ADD_NOTE_REQUESTED'
export const DEAL_DELETE_NOTE_REQUESTED = 'DEAL_DELETE_NOTE_REQUESTED'
export const DEAL_DELETE_NOTE_SUCCESS = 'DEAL_DELETE_NOTE_SUCCESS'
export const DEAL_NOTES_FETCH_REQUESTED = 'DEAL_NOTES_FETCH_REQUESTED'
export const DEAL_NOTES_FETCH_SUCCESS = 'DEAL_NOTES_FETCH_SUCCESS'
export const DEAL_UPDATE_NOTE_REQUESTED = 'DEAL_UPDATE_NOTE_REQUESTED'
export const DEAL_UPDATE_NOTE_SUCCESS = 'DEAL_UPDATE_NOTE_SUCCESS'
export const DELETE_DEAL_TASK_REQUESTED = 'DELETE_DEAL_TASK_REQUESTED'
export const DELETE_DEAL_TASK_SUCCESS = 'DELETE_DEAL_TASK_SUCCESS'
export const DEAL_ACTIVITY_FETCH_REQUESTED = 'DEAL_ACTIVITY_FETCH_REQUESTED'
export const DEAL_ACTIVITY_FETCH_SUCCESS = 'DEAL_ACTIVITY_FETCH_SUCCESS'
export const DEAL_DATE_UPDATE_SUCCESS = 'DEAL_DATE_UPDATE_SUCCESS'
export const DEAL_DATE_UPDATE_REQUESTED = 'DEAL_DATE_UPDATE_REQUESTED'
export const PROPOSALS_SEND_FOR_REVIEW_REQUESTED = 'PROPOSALS_SEND_FOR_REVIEW_REQUESTED'
export const PROPOSALS_SEND_FOR_REVIEW_SUCCESS = 'PROPOSALS_SEND_FOR_REVIEW_SUCCESS'
export const APPROVE_PROPOSALS_REQUESTED = 'APPROVE_PROPOSALS_REQUESTED'
export const APPROVE_PROPOSALS_SUCCESS = 'APPROVE_PROPOSALS_SUCCESS'
export const DEAL_UPDATE_PROPOSALS_FOLLOWUP_REQUESTED = 'DEAL_UPDATE_PROPOSALS_FOLLOWUP_REQUESTED'
export const DEAL_UPDATE_PROPOSALS_FOLLOWUP_SUCCESS = 'DEAL_UPDATE_PROPOSALS_FOLLOWUP_SUCCESS'
export const DEAL_BOARD_CONTRACTOR_AWARDED_UPDATE_REQUESTED =
  'DEAL_BOARD_CONTRACTOR_AWARDED_UPDATE_REQUESTED'
export const DEAL_BOARD_CONTRACTOR_AWARDED_UPDATE_SUCCESS =
  'DEAL_BOARD_CONTRACTOR_AWARDED_UPDATE_SUCCESS'
export const DEAL_FOLLOWUP_DATE_UPDATE_REQUESTED = 'DEAL_FOLLOWUP_DATE_UPDATE_REQUESTED'
export const DEALS_BOARD_FETCH_DEALS_HEADER = 'DEALS_BOARD_FETCH_DEALS_HEADER'
export const DEAL_SAVE_PROPOSAL_DRAFT = 'DEAL_SAVE_PROPOSAL_DRAFT'
export const DEAL_FOLLOWUP_DATE_UPDATE_SUCCESS = 'DEAL_FOLLOWUP_DATE_UPDATE_SUCCESS'
export const DEAL_HEALTH_ERROR = 'DEAL_HEALTH_ERROR'
export const DEAL_DELETE_SUCCESS = 'DEAL_DELETE_SUCCESS'
export const DEAL_DELETE_REQUESTED = 'DEAL_DELETE_REQUESTED'
export const DEAL_STATUSES_FETCH_REQUESTED = 'DEAL_STATUSES_FETCH_REQUESTED'
export const DEAL_STATUSES_FETCH_SUCCESS = 'DEAL_STATUSES_FETCH_SUCCESS'
export const ORGANIZATION_STATUSES_FETCH_REQUESTED = 'ORGANIZATION_STATUSES_FETCH_REQUESTED'
export const ORGANIZATION_STATUSES_FETCH_SUCCESS = 'ORGANIZATION_STATUSES_FETCH_SUCCESS'
export const DEAL_SUMMARY_INFO_FETCH_REQUESTED = 'DEAL_SUMMARY_INFO_FETCH_REQUESTED'
export const DEAL_SUMMARY_INFO_FETCH_SUCCESS = 'DEAL_SUMMARY_INFO_FETCH_SUCCESS'
export const CLEAR_DEAL_FROM_STORE = 'CLEAR_DEAL_FROM_STORE'
export const FETCH_DEAL_ANALYSIS_REQUESTED = 'FETCH_DEAL_ANALYSIS_REQUESTED'
export const FETCH_DEAL_ANALYSIS_SUCCESS = 'FETCH_DEAL_ANALYSIS_SUCCESS'
export const DEAL_UPDATE_SIDEBAR = 'DEAL_UPDATE_SIDEBAR'
export const FETCH_DEAL_DOCUMENTS_COUNT_REQUESTED = 'FETCH_DEAL_DOCUMENTS_COUNT_REQUESTED'
export const FETCH_DEAL_DOCUMENTS_COUNT_SUCCESS = 'FETCH_DEAL_DOCUMENTS_COUNT_SUCCESS'
